export enum FileInportTabTypes {
  EmployeeFileTab = 0,
  TransactionFileTab = 1,
}
